import SkeletonLoader from '.';

const LessonBreakdownListingSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between pb-4 border-b border-neutral-100 last:border-0 last:pb-0"
        >
          <SkeletonLoader className="h-5 w-40" />
          <div className="flex items-center gap-4">
            <SkeletonLoader className="h-6 w-20 rounded-full" />
            <SkeletonLoader className="h-5 w-5" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LessonBreakdownListingSkeleton;
